
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorInsertPoint as ObiCursorInsertPointElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-insert-point.js';
 
 
 

 
 export const ObiCursorInsertPoint = createComponent({
   react: React,
   tagName: 'obi-cursor-insert-point',
   elementClass: ObiCursorInsertPointElement,
   events: {
     
   }
  });
 
 